export const decodeSessionData = (encodedString) => {
  try {
    if (!encodedString) {
      return null;
    }
    const decoded = decodeURIComponent(atob(encodedString));
    return JSON.parse(decoded);
  } catch (error) {
    console.error('Error decoding session data:', error);
    return null;
  }
};

export const getSessionDataFromUrl = (url) => {
  try {
    const urlObj = new URL(url);
    const sessionParam = urlObj.searchParams.get('session');
    if (!sessionParam) {
      return null;
    }
    return decodeSessionData(sessionParam);
  } catch (error) {
    try {
      const queryString = url.includes('?') ? url.split('?')[1] : url;
      const params = new URLSearchParams(queryString);
      const sessionParam = params.get('session');
      if (!sessionParam) {
        return null;
      }
      return decodeSessionData(sessionParam);
    } catch (e) {
      console.error('Error getting session data from URL:', e);
      return null;
    }
  }
};

